// jshint esversion: 8

export default {
  planner: state => state.planner,
  trip: state => state.trip,
  route: state => state.route,
  deadHeads: state => state.deadHeads,
  stops: state => state.stops,
  quote: state => state.quote
};
